var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('h1',[_c('v-icon',{attrs:{"color":"red","size":"45"}},[_vm._v("mdi-file-pdf-box")]),_vm._v("Descarga Masiva de PDF")],1),_c('massive-pdf-manager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }